module.exports = __webpack_public_path__ + "static/media/10-15.0261d69a.mp3";